import { post, put } from '../Services/http';
import { translate } from '../Services/translation';
import checkout from '../api/checkout';
import { load as loadCart } from './Cart.action';
import { catchError } from './Error.action';

export const CHECKOUT_SET_SELECTED_COMPANY_ADDRESS =
  'CHECKOUT_SET_SELECTED_COMPANY_ADDRESS';
export const CHECKOUT_SET_CUSTOMER_INFO = 'CHECKOUT_SET_CUSTOMER_INFO';
export const CHECKOUT_SET_PRIVATE_CUSTOMER = 'CHECKOUT_SET_PRIVATE_CUSTOMER';
export const CHECKOUT_SET_SIGN_UP = 'CHECKOUT_SET_SIGN_UP';
export const CHECKOUT_SET_DELIVERY = 'CHECKOUT_SET_DELIVERY';
export const CHECKOUT_SET_DELIVERY_LOADING = 'CHECKOUT_SET_DELIVERY_LOADING';
export const CHECKOUT_SET_PAYMENT_LOADING = 'CHECKOUT_SET_PAYMENT_LOADING';
export const CHECKOUT_SET_COUNTRY = 'CHECKOUT_SET_COUNTRY';
export const CHECKOUT_SET_PAYMENT = 'CHECKOUT_SET_PAYMENT';
export const CHECKOUT_SET_CAMPAIGN_CODE = 'CHECKOUT_SET_CAMPAIGN_CODE';
export const CHECKOUT_SET_ORDER_NOTE = 'CHECKOUT_SET_ORDER_NOTE';
export const CHECKOUT_ACCEPT_TERMS_OF_CONDITION =
  'CHECKOUT_ACCEPT_TERMS_OF_CONDITION';
export const CHECKOUT_SUBMIT = 'CHECKOUT_SUBMIT';
export const CHECKOUT_SUBMIT_DONE = 'CHECKOUT_SUBMIT_DONE';
export const CHECKOUT_SUBMIT_ERROR = 'CHECKOUT_SUBMIT_ERROR';
export const CHECKOUT_CLEAR_SUBMIT_ERROR = 'CHECKOUT_CLEAR_SUBMIT_ERROR';
export const CHECKOUT_SET_PAYMENT_WIDGET = 'CHECKOUT_SET_PAYMENT_WIDGET';
export const CHECKOUT_SET_SHIPPING_OPTION = 'CHECKOUT_SET_SHIPPING_OPTION';
export const CHECKOUT_SET_SELECTED_RESELLER = 'CHECKOUT_SET_SELECTED_RESELLER';
export const CHECKOUT_SET_IS_ASSEMBLY_ALLOWED =
  'CHECKOUT_SET_IS_ASSEMBLY_ALLOWED';
export const CHECKOUT_SET_WITHOUT_ASSEMBLY = 'CHECKOUT_SET_WITHOUT_ASSEMBLY';
export const CHECKOUT_SET_ACCEPTED_BONUS = 'CHECKOUT_SET_ACCEPTED_BONUS';
export const CHECKOUT_SET_BONUS_ERROR = 'CHECKOUT_SET_BONUS_ERROR';
export const CHECKOUT_SET_COMPANY_ADDRESS = 'CHECKOUT_SET_COMPANY_ADDRESS';
export const CHECKOUT_SET_ENJOY_SIGNUP = 'CHECKOUT_SET_ENJOY_SIGNUP';
export const CHECKOUT_SET_ENJOY_SIGNUP_ERROR = 'CHECKOUT_SET_ENJOY_SIGNUP_ERROR';

export const setBusinessCustomer = (isBusinessCustomer) => ({
  type: CHECKOUT_SET_PRIVATE_CUSTOMER,
  payload: {
    isBusinessCustomer,
  },
});

export const setSignUp = (signUp) => ({
  type: CHECKOUT_SET_SIGN_UP,
  payload: {
    signUp,
  },
});

export const setAlternativeAddress = (propName, value) => ({
  type: CHECKOUT_SET_CUSTOMER_INFO,
  payload: {
    key: 'alternativeAddress',
    data: {
      [propName]: value,
    },
  },
});

export const setAlternativeCompanyAddress = (propName, value) => ({
  type: CHECKOUT_SET_CUSTOMER_INFO,
  payload: {
    key: 'alternativeCompanyAddress',
    data: {
      [propName]: value,
    },
  },
});

export const setCustomerDetails = (propName, value) => ({
  type: CHECKOUT_SET_CUSTOMER_INFO,
  payload: {
    key: 'customerDetails',
    data: {
      [propName]: value,
    },
  },
});

export const setSelectedReseller = (selectedResellerId) => {
  return ({
    type: CHECKOUT_SET_SELECTED_RESELLER,
    payload: {
      selectedResellerId,  // Just send the value directly
      withAssembly: false,  // The value for withAssembly can be set directly as well
    },
  });
};


export const setIsAssemblyAllowed =
  (isAssemblyAllowed) => (dispatch, getState) => {
    dispatch({
      type: CHECKOUT_SET_IS_ASSEMBLY_ALLOWED,
      payload: {
        isAssemblyAllowed,
      },
    });
    if (!isAssemblyAllowed) {
      setWithAssembly(false);
    }
  };

export const setWithAssembly = (withAssembly) => {
  const assembly = {...withAssembly};
  return ({
    type: CHECKOUT_SET_WITHOUT_ASSEMBLY,
    payload: {
      withAssembly: assembly,
    },
  });
}

export const setDelivery = (systemId) => (dispatch, getState) => {
  dispatch({
    type: CHECKOUT_SET_DELIVERY,
    payload: {
      selectedDeliveryMethod: systemId,
      isDeliveryLoading: true,
    },
  });

  const { payload } = getState().checkout;
  return checkout
    .setDelivery(payload, true)
    .then((response) => response.json())
    .then((result) => {
      dispatch({
        type: CHECKOUT_SET_DELIVERY_LOADING,
        payload: {
          isDeliveryLoading: false,
        },
      });
      dispatch(loadCart());
      if (result !== null && result.paymentWidget.displayDeliveryMethods) {
        const clonedWidget = { ...result.paymentWidget };
        dispatch(setPaymentWidget(clonedWidget));
      }
    })
    .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};

export const setPaymentAndDelivery =
  (paymentMethod, deliveryMethod) => (dispatch) => {
    const selectedPaymentMethod = paymentMethod;
    const selectedDeliveryMethod = deliveryMethod;

    dispatch({
      type: CHECKOUT_SET_DELIVERY,
      payload: {
        selectedDeliveryMethod,
        isDeliveryLoading: true,
      },
    });

    dispatch({
      type: CHECKOUT_SET_PAYMENT,
      payload: {
        selectedPaymentMethod,
        isPaymentLoading: true,
      },
    });

    return checkout.setDeliveryAndPayment(deliveryMethod, paymentMethod, true)
      .then((response) => response.json())
      .then((result) => {
        const clonedWidget = { ...result.paymentWidget };
        dispatch(setPaymentWidget(clonedWidget));
      })
      .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))))
      .finally(() => {
        dispatch({
          type: CHECKOUT_SET_DELIVERY_LOADING,
          payload: {
            isDeliveryLoading: false,
          },
        });
        dispatch({
          type: CHECKOUT_SET_PAYMENT_LOADING,
          payload: {
            isPaymentLoading: false,
          },
        });

        dispatch(loadCart());
      });
  };

let shippingOptionAbortController;
export const setShippingOption = (shippingOption) => (dispatch, getState) => {
  dispatch({
    type: CHECKOUT_SET_SHIPPING_OPTION,
    payload: {
      klarnaSelectedShippingOption: shippingOption,
    },
  });
  const { payload } = getState().checkout;

  shippingOptionAbortController && shippingOptionAbortController.abort();
  shippingOptionAbortController = new AbortController();
  return put(
    'api/klarnacheckout/setShippingOption',
    payload,
    shippingOptionAbortController
  )
    .then((response) => response.json())
    .then((result) => {
      if (result !== null && result.paymentWidget !== null) {
        const clonedWidget = { ...result.paymentWidget };
        dispatch(setPaymentWidget(clonedWidget));      }
    })
    .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))))
    .finally(() => {
      dispatch(loadCart());
    });
};

let countryAbortController;
export const setCountry = (systemId) => (dispatch, getState) => {
  dispatch({
    type: CHECKOUT_SET_COUNTRY,
    payload: {
      selectedCountry: systemId,
    },
  });
  const { payload } = getState().checkout;

  countryAbortController && countryAbortController.abort();
  countryAbortController = new AbortController();
  return put('api/checkout/setCountry', payload, countryAbortController)
    .then((response) => response.json())
    .then((result) => {
      dispatch(loadCart());
      const clonedWidget = { ...result.paymentWidget };
      dispatch(setPaymentWidget(clonedWidget));      dispatch({
        type: CHECKOUT_SET_DELIVERY,
        payload: {
          deliveryMethods: result.deliveryMethods,
          selectedDeliveryMethod: result.selectedDeliveryMethod,
        },
      });
      dispatch({
        type: CHECKOUT_SET_PAYMENT,
        payload: {
          paymentMethods: result.paymentMethods,
          selectedPaymentMethod: result.selectedPaymentMethod,
        },
      });
    })
    .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};

export const setPayment = (systemId) => (dispatch, getState) => {
  dispatch({
    type: CHECKOUT_SET_PAYMENT,
    payload: {
      selectedPaymentMethod: systemId,
      isPaymentLoading: true,
    },
  });
  const { payload } = getState().checkout;

  return checkout
    .setPayment(payload, true)
    .then((response) => response.json())
    .then((result) => {
      dispatch({
        type: CHECKOUT_SET_PAYMENT_LOADING,
        payload: {
          isPaymentLoading: false,
        },
      });
      dispatch(loadCart());
      const clonedWidget = { ...result.paymentWidget };
      dispatch(setPaymentWidget(clonedWidget));    })
    .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};

export const reloadPayment = () => (dispatch, getState) => {
  const { paymentWidget, selectedPaymentMethod } = getState().checkout.payload;
  if (!paymentWidget) {
    return;
  }
  return dispatch(setPayment(selectedPaymentMethod));
};

const setPaymentWidget = (paymentWidget) => ({
  type: CHECKOUT_SET_PAYMENT_WIDGET,
  payload: {
    paymentWidget,
  },
});

export const setAcceptedBonus = (bonusUsed) => ({
  type: CHECKOUT_SET_ACCEPTED_BONUS,
  payload: {
    bonusUsed,
  },
});

const setBonusError = (errorMessage) => ({
  type: CHECKOUT_SET_BONUS_ERROR,
  payload: {
    errorMessage,
  },
});

export const setOrderNote = (orderNote) => ({
  type: CHECKOUT_SET_ORDER_NOTE,
  payload: {
    orderNote,
  },
});

export const acceptTermsOfCondition = (acceptTermsOfCondition) => ({
  type: CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
  payload: {
    acceptTermsOfCondition,
  },
});

export const setCampaignCode = (campaignCode) => ({
  type: CHECKOUT_SET_CAMPAIGN_CODE,
  payload: {
    campaignCode,
  },
});

const setSignedUpForEnjoy = (signedUpForEnjoy) => ({
  type: CHECKOUT_SET_ENJOY_SIGNUP,
  payload: {
    signedUpForEnjoy,
  },
});

const setSignedUpForEnjoyError = (signedUpForEnjoyError) => ({
  type: CHECKOUT_SET_ENJOY_SIGNUP,
  payload: {
    error: signedUpForEnjoyError,
  },
});

let bonusAbortController;
export const setBonus = (bonusToUse) => (dispatch, getState) => {
  const { payload } = getState().checkout;
  const { authenticated } = payload;
  if (!authenticated) {
    return;
  }
  payload.errorMessage = '';

  const { bonusBalance } = payload;
  if (bonusToUse > bonusBalance) {
    dispatch(setBonusError(translate('checkout.cart.bonus.not_have_enough')));
    return;
  }

  payload.bonusUsed = bonusToUse;

  bonusAbortController && bonusAbortController.abort();
  bonusAbortController = new AbortController();
  return post('api/bonusPoints/setBonusPoints', payload, bonusAbortController)
    .then((response) => response.json())
    .then(({ paymentWidget }) => {
      dispatch(setAcceptedBonus(bonusToUse));
      dispatch(loadCart());
      dispatch(setPaymentWidget(paymentWidget));
    })
    .catch((err) => {
      err.response.json().then((err) => {
        if (err.message) {
          dispatch(setBonusError(err.message));
        } else {
          dispatch(submitError(err));
        }
      });
    });
};

let submitCampaignAbortController;
export const submitCampaignCode = () => (dispatch, getState) => {
  const { payload } = getState().checkout;

  submitCampaignAbortController && submitCampaignAbortController.abort();
  submitCampaignAbortController = new AbortController();
  return put(
    '/api/checkout/setCampaignCode',
    payload,
    submitCampaignAbortController
  )
    .then((response) => response.json())
    .then((result) => {
      dispatch(loadCart());
      const clonedWidget = {...result};
      dispatch(setPaymentWidget(clonedWidget.paymentWidget));
      dispatch(
        submitError({
          modelState: {
            campaignCode: [],
          },
        })
      );
    })
    .catch((ex) => {
      dispatch(catchError(ex, (error) => submitError(error)));
      // restore the initial cart
      dispatch(loadCart());
    });
};

export const submit = () => (dispatch, getState) => {
  const { payload } = getState().checkout;
  return _submit('/api/checkout', payload, dispatch);
};

export const verify = (url, orderId, payload) => (dispatch, getState) => {
  const model = getState().checkout.payload;
  model.orderId = orderId;
  model.payload = payload;
  return _submit(url, model, dispatch);
};

let submitAbortController;
const _submit = (url, model, dispatch) => {
  submitAbortController && submitAbortController.abort();
  submitAbortController = new AbortController();
  return post(url, model, submitAbortController)
    .then((response) => response.json())
    .then((result) => {
      dispatch(submitDone(result));
    })
    .catch((ex) => {
      if (ex.response) {
        ex.response.json().then((error) => {
          dispatch(submitError(error));
          dispatch(submitDone(null));
          // reload the cart, it might be changed after validation
          dispatch(loadCart());
        });
      } else {
        dispatch(submitError(ex));
      }
    });
};

let signUpForEnjoyAbortController;
export const signUpForEnjoy = (checked) => (dispatch, getState) => {
  const { payload } = getState().checkout;
  payload.SignedUpForEnjoy = checked;

  signUpForEnjoyAbortController && signUpForEnjoyAbortController.abort();
  signUpForEnjoyAbortController = new AbortController();
  return post(
    '/api/checkout/signUpForEnjoy',
    payload,
    signUpForEnjoyAbortController
  )
    .then((response) => response.json())
    .then(({ SignedUpForEnjoy }) => {
      dispatch(setSignedUpForEnjoy(SignedUpForEnjoy));
    })
    .catch(setSignedUpForEnjoyError);
};

export const submitRequest = () => ({
  type: CHECKOUT_SUBMIT,
  payload: {
    isSubmitting: true,
    errors: [],
  },
});

export const submitDone = (result) => ({
  type: CHECKOUT_SUBMIT,
  payload: {
    result,
    isSubmitting: false,
  },
});

export const submitError = (error) => ({
  type: CHECKOUT_SUBMIT_ERROR,
  payload: {
    error,
  },
});

export const clearSubmitError = () => ({
  type: CHECKOUT_CLEAR_SUBMIT_ERROR,
});
